import React from "react";
import Slide from "./Slide";
import { Grid, Typography, makeStyles, Link } from "@material-ui/core";
import NtkButton from "../services/common/NtkButton";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "7% 7% 5% 7%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap-reverse",
    [theme.breakpoints.down("600")]: {
      marginTop: "30px",
      alignItems: "center",
    },
  },
  spaces: {
    marginBottom: "25px",
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    padding: "50px !important",
    marginTop: "50px !important",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
    },
  },
}));

const LearnLanguages = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item md={5} className={classes.text}>
        <Typography
          gutterBottom
          variant="h2"
          color="primary"
          className={classes.spaces}
        >
          Learn a language.
        </Typography>
        <Typography
          gutterBottom
          variant="h2"
          color="primary"
          className={classes.spaces}
        >
          Change a life.
        </Typography>
        <Typography
          variant="subtitle1"
          color="secondary"
          className={classes.spaces}
        >
          High-quality language learning and translation services for
          professionals and organizations powered by refugee talent.
        </Typography>
        <Link href={"/services/academic"} style={{ textDecoration: "none" }}>
          <NtkButton title={"Languages"} className={classes.spaces} />
        </Link>
      </Grid>
      <Grid container item md={7}>
        <Slide />
      </Grid>
    </Grid>
  );
};

export default LearnLanguages;
